// Wizard phases, in flow order:
//   brand → building → ready → overview (step 1) → compliance (step 2) → submit
export const WIZARD_PHASES = {
  BRAND: 'brand',
  BUILDING: 'building',
  READY: 'ready',
  OVERVIEW: 'overview',
  COMPLIANCE: 'compliance',
};

// The numbered form steps ("Step X of 2").
export const TOTAL_WIZARD_STEPS = 2;
export const WIZARD_STEP_NUMBER = {
  [WIZARD_PHASES.OVERVIEW]: 1,
  [WIZARD_PHASES.COMPLIANCE]: 2,
};

export const STEP_COPY = {
  [WIZARD_PHASES.OVERVIEW]: {
    title: 'Campaign overview',
    subtitle:
      'Define the details for this campaign: what it is and what it should achieve. Your objective and goals shape how we recommend influencers and how we measure success.',
  },
  [WIZARD_PHASES.COMPLIANCE]: {
    title: 'Compliance',
    subtitle: 'Set the rules that keep your campaign safe and compliant.',
  },
};

// Brand social links, edited on step 1. `name` is the form field (the same `brand*Link`
// keys the generated draft and the legacy create form use); `network` is the
// `campaignBrandDetails.socialMediaLinks` key.
export const SOCIAL_LINK_FIELDS = [
  { network: 'instagram', name: 'brandInstagramLink', label: 'Instagram' },
  { network: 'tiktok', name: 'brandTiktokLink', label: 'TikTok' },
  { network: 'twitter', name: 'brandTwitterLink', label: 'X' },
  { network: 'youtube', name: 'brandYoutubeLink', label: 'YouTube' },
];

// Form field names match the existing `/campaign/createV2` payload keys (see
// campaignWizardPayload.js), so the draft, the form and the submit share one shape.
export const OVERVIEW_FIELDS = [
  'name',
  'campaignObjectives',
  'objectiveDetails',
  'campaignDescription',
  'flight_dates',
  'country',
  'region',
  'flight_tz',
  'creatorsAmount',
  'budget',
  'campaignGoals',
  ...SOCIAL_LINK_FIELDS.map(({ name }) => name),
];

// The run's reason keys (draft field names) behind a step 1 field, where the form merges or
// splits draft fields (see draftToFormValues). Any other field's reason is under its own name.
export const FIELD_REASON_KEYS = {
  flight_dates: ['flight_start', 'flight_end'],
  country: ['region'],
};

// Generated from the objective: a new objective re-runs the draft and refreshes these.
export const REGENERATED_FIELDS = ['campaignDescription', 'objectiveDetails', 'campaignGoals'];

export const OBJECTIVE_OPTIONS = [
  {
    // Stored as `reach`, the value the legacy create form and campaign views already use.
    value: 'reach',
    title: 'Awareness',
    description: 'Inform your audience about your product or brand and how it benefits them.',
  },
  {
    value: 'engagement',
    title: 'Engagement',
    description: 'Entice your audience to interact with your content by sharing or commenting.',
  },
  {
    value: 'conversions',
    title: 'Conversion',
    description: 'Drive your audience to perform an action, like a purchase or signing up.',
  },
];

export const DISCLOSURE_OPTIONS = [
  { name: 'COPPA', label: 'COPPA disclosure' },
  { name: 'alcohol', label: 'Alcohol (Wine and Spirits)' },
  { name: 'pharmaISI', label: 'Pharma ISI Disclosure Guidelines' },
];

export const FTC_ASSET_EXTENSIONS = ['doc', 'docx', 'txt', 'rtf', 'pdf', 'png', 'jpeg', 'jpg'];
export const FTC_ASSET_MAX_MB = 5;

export const DATE_FORMAT = 'YYYY-MM-DD';
// What the date range field shows; it still accepts typed DATE_FORMAT dates, and the
// payload keeps DATE_FORMAT.
export const DATE_DISPLAY_FORMAT = 'MMM D, YYYY';

// The draft's `flight_tz` is one of the BE's ML constraint labels (FieldConstraints), while
// the form stores IANA zones.
export const DRAFT_TIMEZONE_TO_IANA = {
  'UTC -5 (EST / New York)': 'America/New_York',
  'UTC -6 (Central / Chicago)': 'America/Chicago',
  'UTC -7 (Mountain / Denver)': 'America/Denver',
  'UTC -8 (Pacific / Los Angeles)': 'America/Los_Angeles',
};
